import utilits from '@/assets/utilits/request.js'
export default {
  namespaced: true,
  state: {
    userInfo: null,
    routerClickEvent: -9
  },
  mutations: {
    routerClickVale (state) {
      state.routerClickEvent = state.routerClickEvent + 1
    }
  },
  actions: {
    getlogs ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/getlogs', obj, callback)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/system.js